import clsx from 'clsx';
import { ReactNode } from 'react';

interface Props extends BaseProps {
  children: ReactNode;
  className?: string;
  divider?: boolean;
  icon?: ReactNode | null;
}

export const MenuItem = ({
  children,
  className,
  divider = false,
  icon = null,
  primaryText,
  secondaryText,
  ...rest
}: Props) => {
  return (
    <li
      role="menuitem"
      className={clsx(
        className,
        'flex items-center gap-2 py-2 px-4 text-white',
        {
          'border-t border-border-dark': divider,
          'cursor-pointer hover:bg-primary': rest.onClick !== undefined,
        }
      )}
      {...rest}
    >
      {icon}
      {children}
    </li>
  );
};
